import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormatterPipe } from "./formatter.pipe";
import { SortPipe } from "./sort.pipe";

@NgModule({
  declarations: [FormatterPipe, SortPipe],
  imports: [CommonModule],
  exports: [FormatterPipe, SortPipe]
})
export class PipesModule {}
